<div class="row">
  <app-card [hidHeader]="false" cardTitle="Cadastro Paciente" [options]="false" class="col-sm-12" id="inicioPagina">
    <div class="row ">
      <div class="col-sm-6 col-xl-6 ">
        <label class="sub-title">Nome</label>
        <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
      </div>
      <div class="col-sm-12 col-xl-3 ">
        <label class="sub-title">CPF</label>
        <input type="text" class="form-control"
          placeholder="">
      </div>
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Telefone </label>
        <input type="text" class="form-control" 
          name="telContato" placeholder="">
      </div>
    </div>   
  

    <div class="row">
      <div class="col-sm-6 col-xl-9">
        <label class="sub-title">Nome da Mae</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Data Nascimento</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>
    <br>  <br>

    <div class="row">
      <div class="col-sm-6 col-xl-9">
        <label class="sub-title">Município</label>
        <input type="text" class="form-control"  name="appFacebook" placeholder="">
      </div>
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Escolaridade</label>
        <input type="text" class="form-control"  name="token" placeholder="">
      </div>
    </div>
    <br>  <br>
  

    <div class="row">
      <div class="col-sm-12 ">
        <button type="button" class="btn btn-warning float-left " >
          <i class="feather icon-arrow-left mr-2 f-18"></i>
          Voltar
        </button>
        <button type="button" class="btn btn-primary float-right " >
          <i class="feather icon-check-circle mr-2 f-18"></i>
          Salvar
        </button>
      </div>
    </div>
  </app-card>
</div>
